import { Component, Input, OnInit, ViewChild, OnDestroy} from '@angular/core';
import { MatSort } from "@angular/material/sort";
import { MatStepper } from "@angular/material/stepper";
import { MatTableDataSource } from "@angular/material/table";
import { UnidadEtapasService} from "../_services/unidad-etapas.service";
import { EstudioService} from "../../estudio.service";
import { GapiPickerService} from "../../../../_services/gapi-picker";
import { HtmlEntitiesCleanerPipe} from "../../_pipes/html-entities-cleaner.pipe";
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';
import { MatDialog } from '@angular/material/dialog';
import { CompartirRubricaClassroomComponent } from '../compartir-rubrica-classroom/compartir-rubrica-classroom.component';


@Component({
    selector: 'rubrica-unidad',
    standalone: false,
    templateUrl: 'rubrica-unidad.component.html',
    styleUrls: ['rubrica-unidad.component.scss','../../unidad-etapas/unidad-etapas-generales.scss'],
    providers: [HtmlEntitiesCleanerPipe]
})

export class RubricaUnidadComponent implements OnInit, OnDestroy {

    @Input()
    unidadID: number | string;
    @Input()
    unidadTitle: String;
    @Input()
    isFamilia = false;
    @Input()
    areas: any[];

    cargandoSpreadsheet = false;

    displayedColumns = ['Meta', 'Criterio', 'ft', 'mt', 'Evidencias'];
    rubrica: MatTableDataSource<any>;
    rawData: any[] = [];
    @ViewChild(MatSort, { static: false }) sort: MatSort;

    stepperControl: MatStepper;

    filterForm = new UntypedFormGroup({
        materias: new UntypedFormControl([])
    });
    filterFormSubscription: Subscription;

    constructor(private unidadEtapasService: UnidadEtapasService,
                private estudioService: EstudioService,
                private gapiPickerService: GapiPickerService,
                private htmlEntitiesCleanerPipe: HtmlEntitiesCleanerPipe,
                private globalService: GlobalService,
                public matDialogRef: MatDialog
                ) {
        // this.gapiPickerService.getPickerServiceObservable().subscribe(data => {
        //     if (!data) {
        //         return false;
        //     }

        //     if (data.tipo == 'cargar-boton-classroom') {
        //         this.cargandoSpreadsheet = false;
        //         this.gapiPickerService.createClassRoomButton('widget-div', data.url);
        //         this.stepperControl.next();
        //     }
        // });
    }

    ngOnInit() {
        this.unidadEtapasService.getRubricaUnidad(this.unidadID).subscribe(res => {
            const extractedData = this.estudioService.extractData(res);
            this.setData(extractedData);
            this.filterFormSubscription = this.filterForm.valueChanges.subscribe(
                val => {
                    this.setData(extractedData.filter(item => {
                        return (
                            (item.areas ? this.globalService.intersectionArrays(item.areas, val.materias).length > 0 : false)
                             || val.materias.length === 0
                        );
                    }));
                }
            );
        }, err => {
        });
    }

    setData(data) {
        this.rawData = data;
        this.rubrica = new MatTableDataSource(data);
        this.rawData.forEach(fila => {
            fila.txtES = this.htmlEntitiesCleanerPipe.transform(fila.txtES);
            fila.txtEN = this.htmlEntitiesCleanerPipe.transform(fila.txtEN);
            fila.txtFR = this.htmlEntitiesCleanerPipe.transform(fila.txtFR);
        });
    }

    crearSpreadsheet(stepper) {
        const data = {
            titulo: `Rúbrica de unidad-${this.unidadID}`,
            nombre: this.unidadTitle,
            datos: this.rawData,
            tipo: 'unidad'
        };
        this.stepperControl = stepper;
        this.cargandoSpreadsheet = true;
        this.gapiPickerService.initSpreadsheet(data);
    }

    dialogoCompartir() {
        this.matDialogRef.open(CompartirRubricaClassroomComponent, {
        width: '75%',
        // height: '75%',
        // maxWidth: '100vw !important',
        // maxHeight: 'calc(-64px + 100vh)',
        // position: { bottom: '0'},
        // disableClose: true,
        data: {
          titulo: `Rúbrica de unidad-${this.unidadID}`,
          unidadId: this.unidadID,
          nombre: this.unidadTitle,
          datos: this.rawData,
          tipo: 'unidad'
        }
      });
    }

    ngOnDestroy(): void {
        if (this.filterFormSubscription) {
            this.filterFormSubscription.unsubscribe();
        }
    }
}
